import React from "react";
import { motion } from "framer-motion";
import {
  FaWallet,
  FaChartPie,
  FaGamepad,
  FaServer,
} from "react-icons/fa";

const Wallet = () => {
  return (
    <section id="wallet" className="py-16 px-6 bg-cover bg-center relative">
      <div className="absolute inset-0 bg-black bg-opacity-80"></div>

      <div className="relative max-w-6xl mx-auto text-center">
        <motion.h2
          className="text-4xl font-bold text-yellow-400 mb-8 inline-block border-b-4 border-red-600 px-4 pb-2"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Menelik Wallet Web Service
        </motion.h2>

        <p className="text-gray-300 text-lg mb-10">
          Manage your Menelik funds securely and efficiently.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <motion.div
            className="bg-gray-900 bg-opacity-50 p-6 rounded-xl shadow-lg border-l-4 border-yellow-400 flex items-start space-x-4"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <FaWallet className="text-yellow-400 text-4xl" />
            <div>
              <h3 className="text-xl font-semibold text-red-400">Why Choose Menelik Wallet?</h3>
              <ul className="list-disc ml-6 text-gray-300 mt-2 space-y-1">
                <li>Generate new addresses to receive payments.</li>
                <li>Send Menelik (MENEL) quickly and securely.</li>
                <li>Check available, pending, and total balances.</li>
                <li>Track recent transactions easily.</li>
                <li>Full control over your UTXOs.</li>
              </ul>
            </div>
          </motion.div>

          <motion.div
            className="bg-gray-900 bg-opacity-50 p-6 rounded-xl shadow-lg border-l-4 border-red-600 flex items-start space-x-4"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <FaServer className="text-yellow-400 text-4xl" />
            <div>
              <h3 className="text-xl font-semibold text-yellow-400">SmartNode Management</h3>
              <ul className="list-disc ml-6 text-gray-300 mt-2 space-y-1">
                <li>Add or remove nodes easily.</li>
                <li>Monitor performance and rewards.</li>
                <li>Optimize node configuration.</li>
                <li>View detailed node statistics.</li>
              </ul>
            </div>
          </motion.div>

          <motion.div
            className="bg-gray-900 bg-opacity-50 p-6 rounded-xl shadow-lg border-l-4 border-yellow-400 flex items-start space-x-4"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <FaChartPie className="text-yellow-400 text-4xl" />
            <div>
              <h3 className="text-xl font-semibold text-red-400">Menelik Staking</h3>
              <ul className="list-disc ml-6 text-gray-300 mt-2 space-y-1">
                <li>Earn passive income with staking.</li>
                <li>Rewards based on staking amount and duration.</li>
                <li>Monitor performance and rewards.</li>
                <li>Optimize settings for maximum gains.</li>
              </ul>
            </div>
          </motion.div>

          <motion.div
            className="bg-gray-900 bg-opacity-50 p-6 rounded-xl shadow-lg border-l-4 border-red-600 flex items-start space-x-4"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <FaGamepad className="text-yellow-400 text-4xl" />
            <div>
              <h3 className="text-xl font-semibold text-yellow-400">Play & Earn Rewards</h3>
              <ul className="list-disc ml-6 text-gray-300 mt-2 space-y-1">
                <li>Participate in exciting games and win MENEL.</li>
                <li>Earn rewards based on your performance.</li>
                <li>Track your progress with detailed stats.</li>
                <li>Compete in challenges and unlock bonuses.</li>
              </ul>
            </div>
          </motion.div>
        </div>

        <p className="text-center text-gray-300 mt-10 text-lg font-semibold">
          🚀 Explore all the possibilities of Menelik Wallet and take your crypto experience to the next level.
        </p>
      </div>
    </section>
  );
};

export default Wallet;
